var _style, _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _g3, _g4, _path7, _ellipse, _path8, _path9, _path10, _path11, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationRemotesearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850 550",
    style: {
      enableBackground: "new 0 0 850 550"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000067958517109460968220000005318993688836156330_);}\n\t.st3{fill:#A0616A;}\n\t.st4{fill:#2F2E41;}\n\t.st5{fill:#3F3D56;}\n\t.st6{fill:#6C63FF;}\n\t.st7{fill:#CCCCCC;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527.7,389.8H316.1c-17.8,0-32.2-14.5-32.2-32.2V146.1c0-17.8,14.5-32.2,32.2-32.2h211.5 c17.8,0,32.2,14.5,32.2,32.2v211.5C560,375.4,545.5,389.8,527.7,389.8z M316.1,119c-14.9,0-27.1,12.2-27.1,27.1v211.5 c0,14.9,12.2,27.1,27.1,27.1h148.2c49.9,0,90.5-40.5,90.5-90.5V146.1c0-14.9-12.2-27.1-27.1-27.1C527.7,119,316.1,119,316.1,119z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339,141c-10,0-18.1,8.1-18.1,18.1v28.4c0,10,8.1,18.1,18.1,18.1h28.4c10,0,18.1-8.1,18.1-18.1v-28.4 c0-10-8.1-18.1-18.1-18.1H339z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339,221c-10,0-18.1,8.1-18.1,18.1v28.4c0,10,8.1,18.1,18.1,18.1h28.4c10,0,18.1-8.1,18.1-18.1v-28.4 c0-10-8.1-18.1-18.1-18.1H339L339,221z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339,301c-10,0-18.1,8.1-18.1,18.1v28.4c0,10,8.1,18.1,18.1,18.1h28.4c10,0,18.1-8.1,18.1-18.1v-28.4 c0-10-8.1-18.1-18.1-18.1H339z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.5581,
    y1: 3815.6582,
    x2: 419.9774,
    y2: 3757.1287,
    gradientTransform: "matrix(1 0 0 1 0 -3679.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M357.8,71.6c-12.6,0-22.8,10.2-22.8,22.8v35.8c0,12.6,10.2,22.8,22.8,22.8h35.8c12.6,0,22.8-10.2,22.8-22.8 V94.6c0-12.6-10.2-22.8-22.8-22.8L357.8,71.6L357.8,71.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129921730643753620390000006144573364656464277_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.8958,
    y1: 3892.4338,
    x2: 534.3965,
    y2: 3892.4338,
    gradientTransform: "matrix(1 0 0 1 0 -3679.9995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#ECB365"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37335"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129921730643753620390000006144573364656464277_)"
    },
    d: "M475.7,171.7 c-12.6,0-22.8,10.2-22.8,22.8v35.8c0,12.6,10.2,22.8,22.8,22.8h35.8c12.6,0,22.8-10.2,22.8-22.8v-35.8c0-12.6-10.2-22.8-22.8-22.8 H475.7L475.7,171.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "424.4,532.1 417.2,532.1 414,503.3 424.7,503.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M401.2,543.8c0,1.8,1.4,3.3,3.2,3.3l14.5,0.1l2.6-5.1l1,5.1h5.4l-1.4-18.3l-1.9-0.1l-7.8-0.5l-2.5-0.2v5.2 l-11.6,7.9C401.7,541.6,401.2,542.7,401.2,543.8L401.2,543.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "461.4,532.1 454.2,532.1 451,503.3 461.7,503.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.2,543.8c0,1.8,1.4,3.3,3.2,3.3l14.5,0.1l2.6-5.1l1,5.1h5.4l-1.4-18.3l-1.9-0.1l-7.8-0.5l-2.5-0.2v5.2 l-11.6,7.9C438.7,541.6,438.2,542.7,438.2,543.8L438.2,543.8z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M395.9,300l29.4,1l27.9,6.2c0,0-2.8,3.4,6.5,12.7c0,0,12.4,21.8,3.7,42.9l-3.7,84.4c0,0,10.9,59.5,2.6,78.5 l-11,0.6l-18.6-78.4l-9.1-84.5l-4.4,83.2c0,0,16.6,57.1,6.1,79.8l-11.8-0.6l-20.4-79c0,0-8.6-91.2-7.5-108.6 C387.2,320.5,395.9,300,395.9,300L395.9,300z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M494.9,166.6c-4.1,1.1-6.4,5.1-5.4,9.2c0.4,1.8,1.6,3.3,3.1,4.4l0,0L492,194l10.6,4.9l0.9-21.3h-0.1 c1-1.6,1.3-3.6,0.7-5.5C503,168,499,165.5,494.9,166.6L494.9,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M435.7,216.1c-2.2-2.2-3.5-5.2-3.5-8.4c-0.1-4.4,2.1-8.3,5.9-10.6c4.3-2.7,9.7-2.3,13.7,0.6l33.3,25.1 l6-36.1l12.7,4.1l-3,47c-0.2,3.3-2,6.2-5,7.8c-2.9,1.6-6.3,1.5-9.2-0.1l-48.1-27.4C437.3,217.4,436.5,216.8,435.7,216.1 L435.7,216.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M384.9,146.4c2.1,3.6,1,8.2-2.7,10.3c-1.6,1-3.5,1.3-5.2,1l0,0l-9.4,10.2l-11-3.9l14.4-15.7v0.1 c0.5-1.8,1.7-3.4,3.4-4.5C378.2,141.6,382.8,142.8,384.9,146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M389,222.8l-53.4-14.4c-3.2-0.9-5.7-3.3-6.6-6.4c-1-3.1-0.2-6.5,1.9-9l30.9-35.5l11.9,6.1l-21.2,29.8 l41.3,5.7c5,0.6,9,4.3,10.2,9.2c1.1,4.3-0.2,8.6-3.3,11.6c-2.3,2.2-5.3,3.5-8.5,3.5C391.1,223.2,390.1,223.1,389,222.8L389,222.8 z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M465.2,312.4l-74.7,3.4c-2-3.1-1.5-7.8,1.4-13.7c10.9-22.2,2.6-64.1-2.9-85.9c-1.6-6.1,2.7-12.2,8.9-12.8 l7-0.7l6.5-19.8h22.8l9.5,10.8l16.1,9.7c-2.9,30.1-15.4,72.6,2.3,94C465.9,302,467,307.1,465.2,312.4L465.2,312.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3162 -0.9487 0.9487 0.3162 134.2107 508.4553)",
    className: "st3",
    cx: 419.8,
    cy: 161.1,
    rx: 22.2,
    ry: 22.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M445,146.9c3.1-11.3-30.6-20.9-37.1-11.8c-1-1.3-4.3-2-5.9-1.7c-1.5,0.4-2.9,1.4-4.2,2.3 c-1.7,1.4-3.5,2.8-4.6,4.7c-1.1,1.9-1.3,4.5,0.2,6.2c1.2,1.3,3.2,8.3,4.9,8.6c1.2,0.2,2.2,0.4,3.1,0.5c0.7-1.2,2.8-2.6,2.6-3.9 c1.2,0.7,0.7,2.1,0.5,3.5c-0.7,4.7-18.5,40.6-8.3,30c1,0.6,2.2,1.2,3.7,1.7c2.5-3.6,4.4-8,5.8-12.5v0.1c0.4,3.9,3.3,7.1,7.1,8.2 c15.3,4.4,27.5-2,31.8-13.8c-1.6-3.2-2.2-2.8-2.1-2.9c1.9-1.3,4.6-0.4,5.4,1.7c0.2,0.6,0.4,1.2,0.6,1.6 C450.8,161.7,453.4,162.8,445,146.9L445,146.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M434.4,138.7l-1.6-8c-0.1-0.6-0.2-1.4,0-2c0.4-0.7,1.4-1.1,2.2-1c0.9,0.1,1.5,1,2.3,1.1c3,0.5,6.9-2.5,8,5 c0.4,3.1,5.4,3.4,7.1,6.1c1.7,2.7,1.9,6.5-0.4,8.7c-1.8,1.7-4.7,1.9-7,1.1s-4.3-2.7-5.9-4.6c-1.6-1.9-3.2-3.9-5-5.7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M446.2,150.8c-6.1-0.9-10.2-3.1-12.3-6.6c-2.8-4.6-0.9-9.7-0.9-9.9l1.3,0.4c0,0-1.7,4.7,0.7,8.7 c1.9,3.1,5.7,5.1,11.3,5.9L446.2,150.8z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M501.8,50.2c3.3-5.1,5.3-11.2,5.3-17.7c0-17.9-14.5-32.4-32.4-32.4c-17.9,0-32.4,14.5-32.4,32.4 s14.5,32.4,32.4,32.4c6.6,0,12.8-2,18-5.4l27.4,25.7c1.3,1.2,2.9,1.7,4.5,1.7l0,0c1.7,0,3.4-0.6,4.7-2c2.5-2.7,2.3-6.7-0.3-9.2 L501.8,50.2 M455.2,32.5c0-10.8,8.7-19.4,19.4-19.4s19.4,8.7,19.4,19.4s-8.7,19.4-19.4,19.4C464,51.9,455.2,43.1,455.2,32.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M130.2,548.7c0,0.7,0.5,1.3,1.3,1.3h587c0.7,0,1.3-0.5,1.3-1.3c0-0.7-0.5-1.3-1.3-1.3h-587 C130.7,547.4,130.2,547.9,130.2,548.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationRemotesearch);
export default __webpack_public_path__ + "static/media/illustration_remotesearch.59cf9020b999fb730d3eda18119f247a.svg";
export { ForwardRef as ReactComponent };